import { KNOWN_ERROR } from "./errors";

export const DELIVERYTEAM_ORDER_STATUS = [
    'DRAFT',
    'EXPIRED',
    'SCHEDULED',
    'PLACED',
    'ACCEPTED',
    'GOING_TO_PICKUP',
    'WAITING_AT_PICKUP',
    'PICKED_UP',
    'GOING_TO_DELIVERY',
    'WAITING_AT_DELIVERY',
    'DELIVERED',
    'UNDELIVERABLE',
    'UNDELIVERABLE_LEAVE_AT_DOOR',
    'UNDELIVERABLE_DISCARDED',
    'UNDELIVERABLE_RETURNING_TO_PICKUP',
    'UNDELIVERABLE_COMPLETED',
    'CANCELLED',
    'COMPLETED',
] as const;



export const DELIVERYTEAM_POST_ACCEPT_COURIER_STATUSES = [
    'GOING_TO_PICKUP',
    'WAITING_AT_PICKUP',
    'PICKED_UP',
    'GOING_TO_DELIVERY',
    'WAITING_AT_DELIVERY',
    'DELIVERED',
    'UNDELIVERABLE',
    'UNDELIVERABLE_LEAVE_AT_DOOR',
    'UNDELIVERABLE_DISCARDED',
    'UNDELIVERABLE_RETURNING_TO_PICKUP',
    'UNDELIVERABLE_COMPLETED',
] as const satisfies readonly DeliveryteamOrderStatus[];

export const BEFORE_DELIVERY_STATUSES = [
    'GOING_TO_DELIVERY',
    'WAITING_AT_DELIVERY',
    'UNDELIVERABLE',
] as const satisfies readonly DeliveryteamOrderStatus[];

export const BEFORE_PICKUP_STATUSES = [
    'GOING_TO_PICKUP',
    'WAITING_AT_PICKUP',
] as const satisfies readonly DeliveryteamOrderStatus[];

export const COMPLETED_STATUSES_BY_COURIER = [
    'DELIVERED',
    'UNDELIVERABLE_COMPLETED',
] as const satisfies readonly DeliveryteamOrderStatus[];


export type DeliveryteamOrderStatus = (typeof DELIVERYTEAM_ORDER_STATUS)[number];
export const DELIVERYTEAM_ORDER_STATUS_OBJ = DELIVERYTEAM_ORDER_STATUS.reduce((acc, status) => {
    acc[status] = status;
    return acc;
}, {} as Record<DeliveryteamOrderStatus, DeliveryteamOrderStatus>);


export const deliveryteamOrderAllowedTransitions: Record<DeliveryteamOrderStatus, DeliveryteamOrderStatus[]> = {
    DRAFT: ['SCHEDULED', 'PLACED', 'EXPIRED'],
    EXPIRED: [],

    SCHEDULED: ['PLACED', 'CANCELLED'],
    PLACED: ['ACCEPTED', 'CANCELLED'],
    ACCEPTED: [
        'GOING_TO_PICKUP',
        'WAITING_AT_PICKUP',
        'PICKED_UP',
        'GOING_TO_DELIVERY',
        'WAITING_AT_DELIVERY',
        'DELIVERED',
        // 'UNDELIVERABLE',
        // 'UNDELIVERABLE_LEAVE_AT_DOOR',
        // 'UNDELIVERABLE_DISCARDED',
        // 'UNDELIVERABLE_RETURNING_TO_PICKUP',
        // 'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    GOING_TO_PICKUP: [
        'WAITING_AT_PICKUP',
        'PICKED_UP',
        'GOING_TO_DELIVERY',
        'WAITING_AT_DELIVERY',
        'DELIVERED',
        // 'UNDELIVERABLE',
        // 'UNDELIVERABLE_LEAVE_AT_DOOR',
        // 'UNDELIVERABLE_DISCARDED',
        // 'UNDELIVERABLE_RETURNING_TO_PICKUP',
        // 'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    WAITING_AT_PICKUP: [
        'PICKED_UP',
        'GOING_TO_DELIVERY',
        'WAITING_AT_DELIVERY',
        'DELIVERED',
        // 'UNDELIVERABLE',
        // 'UNDELIVERABLE_LEAVE_AT_DOOR',
        // 'UNDELIVERABLE_DISCARDED',
        // 'UNDELIVERABLE_RETURNING_TO_PICKUP',
        // 'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    PICKED_UP: [
        'GOING_TO_DELIVERY',
        'WAITING_AT_DELIVERY',
        'DELIVERED',
        'UNDELIVERABLE',
        // 'UNDELIVERABLE_LEAVE_AT_DOOR',
        // 'UNDELIVERABLE_DISCARDED',
        // 'UNDELIVERABLE_RETURNING_TO_PICKUP',
        // 'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    GOING_TO_DELIVERY: [
        'WAITING_AT_DELIVERY',
        'DELIVERED',
        'UNDELIVERABLE',
        'UNDELIVERABLE_LEAVE_AT_DOOR',
        'UNDELIVERABLE_DISCARDED',
        'UNDELIVERABLE_RETURNING_TO_PICKUP',
        'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    WAITING_AT_DELIVERY: [
        'DELIVERED',
        'UNDELIVERABLE',
        'UNDELIVERABLE_LEAVE_AT_DOOR',
        'UNDELIVERABLE_DISCARDED',
        'UNDELIVERABLE_RETURNING_TO_PICKUP',
        'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    DELIVERED: [
        // 'UNDELIVERABLE',
        // 'UNDELIVERABLE_LEAVE_AT_DOOR',
        // 'UNDELIVERABLE_DISCARDED',
        // 'UNDELIVERABLE_RETURNING_TO_PICKUP',
        // 'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    UNDELIVERABLE: [
        'UNDELIVERABLE_LEAVE_AT_DOOR',
        'UNDELIVERABLE_DISCARDED',
        'UNDELIVERABLE_RETURNING_TO_PICKUP',
        'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    UNDELIVERABLE_LEAVE_AT_DOOR: [
        // 'UNDELIVERABLE',
        'UNDELIVERABLE_DISCARDED',
        'UNDELIVERABLE_RETURNING_TO_PICKUP',
        'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    UNDELIVERABLE_DISCARDED: [
        // 'UNDELIVERABLE',
        'UNDELIVERABLE_LEAVE_AT_DOOR',
        'UNDELIVERABLE_RETURNING_TO_PICKUP',
        'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    UNDELIVERABLE_RETURNING_TO_PICKUP: [
        // 'UNDELIVERABLE',
        'UNDELIVERABLE_LEAVE_AT_DOOR',
        'UNDELIVERABLE_DISCARDED',
        'UNDELIVERABLE_COMPLETED',
        'CANCELLED',
        'COMPLETED'
    ],
    UNDELIVERABLE_COMPLETED: [
        'CANCELLED',
        'COMPLETED'
    ],
    CANCELLED: ['COMPLETED'],
    COMPLETED: [],
};

export const isDeliveryteamOrderAllowedToCancel = (orderStatus: DeliveryteamOrderStatus) => {
    try {
        return isDeliveryteamOrderAllowedStatusChange(orderStatus, 'CANCELLED');
    } catch (error) {
        return false;
    }
}

export const isDeliveryteamOrderAllowedToAccept = (orderStatus: DeliveryteamOrderStatus) => {
    try {
        return isDeliveryteamOrderAllowedStatusChange(orderStatus, 'ACCEPTED');
    } catch (error) {
        return false;
    }
}

export function isDeliveryteamOrderAllowedStatusChange(from: DeliveryteamOrderStatus, to: DeliveryteamOrderStatus) {
    if (deliveryteamOrderAllowedTransitions[from].includes(to)) {
        return true;
    } else {
        if (typeof window === 'undefined') {
            // Only log on server-side
            console.error(`Deliveryteam order status not allowed to be changed from ${from} to ${to}`);
        }
        throw new KNOWN_ERROR(
            `Deliveryteam order status not allowed to be changed from ${from} to ${to}`,
            "DELIVERYTEAM_ORDER_STATUS_NOT_ALLOWED_TO_BE_CHANGED"
        );
    }
}

export function isDeliveryteamOrderAllowedStatusChange_noerror(
    from: DeliveryteamOrderStatus, to: DeliveryteamOrderStatus
) {
    return deliveryteamOrderAllowedTransitions[from].includes(to);
}

